import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const ColetaPersonalizadaSection = () => {
  return (
    <section className="py-10 md:py-24 bg-white">
      <div className="container">
        <div className="grid md:grid-cols-2 md:gap-16 gap-4 items-center">
          <div className="flex items-center justify-center">
            <ImageSvg
              src="buscamos-s-seu-veiculo.svg"
              alt="Coleta personalizada de veículos"
              className="max-w-[70%] h-auto"
            />
          </div>
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Buscamos o seu veículo onde estiver
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              <strong>Seja na capital ou no interior</strong>, em casa, no
              trabalho, na sua loja ou direto do leilão. Com a experiência de
              quem já atendeu <strong>mais de 3.000 cidades diferentes</strong>{" "}
              , garantimos agilidade, pontualidade e maior comodidade para você.
            </p>

            <Link to="/fazer-cotacao">
              <Button>
                Fazer cotação
                <ArrowRight className="ml-2 h-6 w-6" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
